import { render, staticRenderFns } from "./ShipmentRecordDetail.vue?vue&type=template&id=92d0a8ee&scoped=true&"
import script from "./ShipmentRecordDetail.vue?vue&type=script&lang=js&"
export * from "./ShipmentRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentRecordDetail.vue?vue&type=style&index=0&id=92d0a8ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d0a8ee",
  null
  
)

export default component.exports